module.exports = __webpack_public_path__ + "static/media/eyeBlinkLeft.cab4aa00.obj";